module.exports = __webpack_public_path__ + "media/music/punchy_bass_7-a44ca5ab.mp3";